import {Fill, Stroke} from 'ol/style';

// @ts-ignore
export const setLayers = (state, all) => {
  state.all = all;
};

// @ts-ignore
export const initColors = (state, all) => {
  state.colors = {
    fill: {
      red: new Fill({color: '#FF0000'}),
      green: new Fill({color: '#00FF00'}),
      blue: new Fill({color: '#0000FF'}),
    },
    stroke: {
      red: new Stroke({color: '#990000'}),
      green: new Stroke({color: '#009900'}),
      blue: new Stroke({color: '#000099'}),
    },
  };

};
